import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const servicesApiService = createApi({
  reducerPath: 'servicesApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/service/'),
  endpoints: (builder) => ({
    getServices: builder.query({
      query: (args) => {
        let { id } = args

        if (id) {
          return `get/${id}`
        }

        let query = queryParams(args)

        return `get${query}`
      },
      keepUnusedDataFor: 0
    }),
    createService: builder.mutation({
      query: (body) => ({
        url: `create`,
        method: "POST",
        body
      })
    }),
    // deleteGuideline: builder.mutation({
    //     query: (id) => ({
    //         url: `delete/${id}`,
    //         method: "DELETE"
    //     })
    // }),
    updateService: builder.mutation({
      query: (body) => ({
        url: `update/${body?._id}`,
        method: "PUT",
        body
      })
    })
  })
})

export const {
  useGetServicesQuery,
  useCreateServiceMutation,
  // useDeleteGuidelineMutation,
  useUpdateServiceMutation
} = servicesApiService